import { render, staticRenderFns } from "./PerformanceSettings.vue?vue&type=template&id=76f101a9&"
import script from "./PerformanceSettings.vue?vue&type=script&lang=js&"
export * from "./PerformanceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports